import { USERUPDATE_URLS } from '../../config/config'
import { UserAPICall } from './UserRequestUtil'

export const UserUpdate = async (type,params) => {

  const attrs = Object.entries(params.diff).map(([key, value]) => ({'Name': mapping[key], 'Value': value}))

  const url = USERUPDATE_URLS[type];
  const parameter = {
    username: params.uid,
    attributes: attrs
  }

  const res = await UserAPICall(url,parameter);

  return res;

};

const mapping = {
  familyname: "family_name",
  lastname: "given_name",
  tenantid: "custom:tenant",
  name: "name"
}
